import { setLang } from './all';

const KEY = 'zh';

const obj = setLang(KEY);

export default {
  ...obj
};
